import { http } from './http'
import store from '../store/index'

export default function setup () {
  /**
   * Outward interceptor (request)
   */
  http.interceptors.request.use(config => {
    const user = store.getters['authentication/getUser']

    if (user) {
      const token = store.getters['authentication/getUser'].value
      if (token) {
        config.headers['X-Auth-Token'] = token
      }
    }

    return config
  }, error => {
    return Promise.reject(error)
  })

  /**
   * Inward interceptor (response)
   */
  http.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if ([401, 403].indexOf(error.response.status) > -1) {
        if (error.request.responseURL !== undefined) {
          if (error.request.responseURL.endsWith('auth-tokens')) {
            const message = new Error('Identifiants non reconnus')
            return Promise.reject(message)
          }
          store.dispatch('authentication/logout')
        } else {
          if (error.config.url.endsWith('auth-tokens')) {
            const message = new Error('Identifiants non reconnus')
            return Promise.reject(message)
          }

          store.dispatch('authentication/logout')
        }
      }

      return Promise.reject(error)
    }
  )
}
